import { NavItem as NavigationNavItem } from '@studio/navigation';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const NavItem = styled(NavigationNavItem).attrs({
  NavLink,
})``;

export default NavItem;
